import ControlID from './control-id';

export default {
  ControlID,
};
